module.exports = __webpack_public_path__ + "img/plus-active.b4ad5dc9.svg";